import React, { useEffect, useRef } from "react";
import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from "formik";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { failureAlert, successAlert2, successAlertRefresh } from "../../CommonUtils/SweetAlerts";
import Swal from "sweetalert2";
import * as bie from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";

import { viewImage } from "../../CommonUtils/viewImage";
import * as Yup from "yup";
import allowNumbersOnly, { AllowFloats, handlePaste } from "../../CommonUtils/CommonValidations";
import { ImagePdfBucket } from "../../CommonUtils/ImagesBase64";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import { useState } from "react";
import { config } from "../../CommonUtils/CommonURLS";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import { BsEyeFill } from "react-icons/bs";

export default function LabDtlsDegree({ goNext, paymentDone }) {
  // const Collegetype = useSelector((state) => state?.commonMastersReducer?.CollegeType);
  const dispatch = useDispatch();
  const [building, setBuilding] = useState([]);
  const [floors, setFloors] = useState({});
  const hasFetchedData = useRef(false);
  const validationSchema = Yup.object().shape({
    instructionalArea: Yup.array().of(
      Yup.object().shape({
        labType: Yup.string().required(ERROR_MSG).nullable(),
        labDetails: Yup.string().required(ERROR_MSG).nullable(),
        buildBlockSlno: Yup.string().required(ERROR_MSG).nullable(),
        floorNoBuildBlock: Yup.string().required(ERROR_MSG).nullable(),
        noOfRooms: Yup.string().required(ERROR_MSG).nullable(),
        length: Yup.string().required(ERROR_MSG).nullable(),
        breadth: Yup.string().required(ERROR_MSG).nullable(),
        height: Yup.string().required(ERROR_MSG).nullable(),
        utilization: Yup.string().required(ERROR_MSG).nullable(),
        buildingImg: Yup.string().required(ERROR_MSG).nullable(),
      }),
    ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      instructionalArea: [
        {
          labType: "",
          labDetails: "",
          buildBlockSlno: "",
          floorNoBuildBlock: "",
          noOfRooms: "",
          length: "",
          breadth: "",
          height: "",
          area: "",
          utilization: "",
          buildingImg: "",
        },
      ],
    },
    validationSchema: validationSchema,

    onSubmit: (val) => {
      // Function to check for duplicate labType and labDetails row-wise
      const checkForDuplicates = (instructionalArea) => {
        const seen = new Map(); // A map to track unique (labType, labDetails) pairs with their row index
        const duplicates = [];

        instructionalArea.forEach((item, index) => {
          const labKey = `${item.labType}-${item.labDetails}`;
          if (seen.has(labKey)) {
            // If this combination is already seen, mark it as a duplicate with row info
            duplicates.push({ index, item: item });
          } else {
            seen.set(labKey, index);
          }
        });

        return duplicates; // Return the list of duplicate items with their row index
      };

      const duplicates = checkForDuplicates(val?.instructionalArea);
      if (duplicates.length > 0) {
        // If there are duplicates, show a Swal alert for each duplicate
        duplicates.forEach((duplicate) => {
          const duplicateItem = duplicate.item;
          Swal.fire({
            title: "Duplicate Lab Type/Details Found",
            text: `Row ${duplicate.index + 1}: Lab Type: ${duplicateItem.labType} and Lab Details: ${duplicateItem.labDetails} is repeated.`,
            icon: "warning",
            confirmButtonText: "OK",
            backdrop: false,
          });
        });
        return; // Prevent the form from submitting
      }

      Swal.fire({
        text: "Are you sure you want to submit?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, submit it!",
        cancelButtonText: "No, cancel!",
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          // Process the form data before submission
          val.instructionalArea.forEach((item, index) => {
            let buildBlockSlno = item.buildBlockSlno.split("-")[0];
            if (item.floorNoBuildBlock === "Ground") {
              item.floorNoBuildBlock = 0;
            }
            item.buildBlockSlno = buildBlockSlno;
          });

          let url = config.url.FAC_URL + `LabAreaDetails`;
          CommonAxiosPost(url, val?.instructionalArea, dispatch).then((res) => {
            if (res?.data?.scode === "01") {
              successAlert2(res?.data?.sdesc);
              goNext();
            } else {
              failureAlert("Failed to submit");
            }
          });
        }
      });
    },
  });
  const [genderSelectVisibility, setGenderSelectVisibility] = useState(Array(building?.length).fill(false));
  const handleBuildBlockChange = (e, index) => {
    const updatedVisibility = [...genderSelectVisibility];
    updatedVisibility[index] = e.target.value !== "";
    setGenderSelectVisibility(updatedVisibility);

    formik.handleChange(e);
  };

  function GetFloors(floor_no, index) {
    const floor = floor_no.split("-");
    let url = config.url.FAC_URL + `getFloor/${floor[1]}`;
    CommonAxiosGet(url, dispatch).then((res) => {
      if (res?.data?.scode === "01") {
        setFloors((prevFloors) => ({
          ...prevFloors,
          [index]: res?.data?.getfloors,
        }));
      } else {
        setFloors([]);
      }
    });
  }

  const handleDimensionChange = (e, dimension, index) => {
    const { value } = e.target;
    formik.setFieldValue(`instructionalArea[${index}].${dimension}`, value);
    const length = dimension === "length" ? parseInt(value) : formik.values.instructionalArea[index]?.length || 0;
    const breadth = dimension === "breadth" ? parseInt(value) : formik.values.instructionalArea[index]?.breadth || 0;
    const totalArea = length * breadth;
    formik.setFieldValue(`instructionalArea[${index}].area`, totalArea || "");
  };

  async function GetParticulars() {
    try {
      const url = `${config.url.FAC_URL}getblockfloor`;
      const res = await CommonAxiosGet(url, dispatch);
      if (res?.data?.scode === "01") {
        setBuilding(res?.data?.labdetails);
      } else {
        setBuilding([]);
      }
    } catch (error) {
      console.error("Error fetching block floor data:", error);
      setBuilding([]);
    }

    try {
      const urlllll = `${config.url.FAC_URL}getlabdetails`;
      const res2 = await CommonAxiosGet(urlllll, dispatch);
      if (res2?.data?.scode === "01") {
        const areaDetails =
          res2?.data?.data?.length > 0
            ? res2?.data?.data.map((position) => ({
              labType: position?.lab_type || "",
              labDetails: position?.lab_details || "",
              buildBlockSlno: position?.build_block_name || "",
              floorNoBuildBlock: position?.floor_no_build_block === 0 ? "Ground" : position?.floor_no_build_block || "",
              noOfRooms: position?.no_of_rooms || "",
              length: position?.length || "",
              breadth: position?.breadth || "",
              height: position?.height || "",
              area: position?.area || "",
              utilization: position?.utilization === true ? "true" : position?.utilization === false ? "false" : "",
              buildingImg: position?.building_img || "",
            }))
            : [{ labType: "", labDetails: "", buildBlockSlno: "", floorNoBuildBlock: "", noOfRooms: "", length: "", breadth: "", height: "", area: "", utilization: "", buildingImg: "" }];
        formik.setFieldValue("instructionalArea", areaDetails);
      } else {
        formik.setFieldValue("instructionalArea", [
          {
            labType: "",
            labDetails: "",
            buildBlockSlno: "",
            floorNoBuildBlock: "",
            noOfRooms: "",
            length: "",
            breadth: "",
            height: "",
            area: "",
            utilization: "",
            buildingImg: "",
          },
        ]);
      }
    } catch (error) {
      formik.setFieldValue("instructionalArea", [
        {
          labType: "",
          labDetails: "",
          buildBlockSlno: "",
          floorNoBuildBlock: "",
          noOfRooms: "",
          length: "",
          breadth: "",
          height: "",
          area: "",
          utilization: "",
          buildingImg: "",
        },
      ]);
    }
  }
  useEffect(() => {
    if (!hasFetchedData.current) {
      GetParticulars();
      // GetCollegeType();
      hasFetchedData.current = true;
    }
  }, []);

  return (
    <>
      <h5 className="mb-3 innerheader-new">
        <span>Lab Area Details</span>
      </h5>

      <div className="faculty-form-wrapper">
        <div className="faculty-card">
          <FormikProvider value={formik}>
            <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="affl-form">
              <bie.Alert variant="danger" className="affl-alert">
                <p className="mb-0">
                  <b style={{ color: "red" }}> Note: </b> Don't repeat the same Lab name in same Building block{" "}
                </p>
              </bie.Alert>
              <div className="table-responsive">
                <table className="table table-bordered mt-2">
                  <thead className="table-primary">
                    <tr>
                      <th rowSpan={2} style={{ width: "4%" }}>
                        {" "}
                        S.No <span className="red-number">*</span>
                      </th>
                      <th rowSpan={2} style={{ width: "9%" }}>
                        {" "}
                        Lab Type <span className="red-number">*</span>
                      </th>
                      <th rowSpan={2} style={{ width: "9%" }}>
                        {" "}
                        Lab Name <span className="red-number">*</span>
                      </th>
                      <th rowSpan={2} style={{ width: "10%" }}>
                        {" "}
                        Building / Block Name <span className="red-number">*</span>
                      </th>
                      <th rowSpan={2} style={{ width: "9%" }}>
                        {" "}
                        Level/Floor No. <span className="red-number">*</span>
                      </th>
                      <th rowSpan={2}>
                        {" "}
                        Room No. <span className="red-number">*</span>
                      </th>
                      <th colSpan={4}>
                        {" "}
                        Measurements of Room
                        {/* {Collegetype} */}
                        <span className="red-number">*</span>
                      </th>
                      <th rowSpan={2}>
                        {" "}
                        Status of Utilization <span className="red-number">*</span>
                      </th>
                      <th rowSpan={2}>
                        {" "}
                        Upload Room Image <span className="red-number">*</span>
                      </th>
                      <th rowSpan={2}>
                        Action<span className="red-number">*</span>
                      </th>
                    </tr>
                    <tr>
                      <th>Length <span className="red-number">*</span></th>
                      <th>Breadth <span className="red-number">*</span></th>
                      <th>Height <span className="red-number">*</span></th>
                      <th>

                        Area in (SqFt)
                        {/* {Collegetype} */}
                        <span className="red-number">*</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ textAlign: "center" }}>
                    <FieldArray name="instructionalArea">
                      {({ push, remove }) => {
                        return (
                          <>
                            {formik?.values?.instructionalArea?.map((detail, index) => (
                              <tr key={index}>
                                <td>
                                  <center>{index + 1}</center>
                                </td>
                                <td>
                                  <Field as="select" className="form-control mt-0" name={`instructionalArea[${index}].labType`} style={{ width: "10rem" }}>
                                    <option value="">--Select--</option>
                                    <option value="Laboratory (For First Year)">Laboratory (For First Year)</option>
                                    <option value="Laboratory (other than First Year)">Laboratory (other than First Year)</option>
                                    <option value="Laboratory for Post Graduate courses">Laboratory for Post Graduate courses</option>
                                  </Field>
                                  <ErrorMessage name={`instructionalArea[${index}].labType`} component="div" className="text-danger" />
                                </td>
                                <td>
                                  <Field type="text" className="form-control mt-0" name={`instructionalArea[${index}].labDetails`} placeholder="Lab Name" style={{ width: "10rem" }} />
                                  <ErrorMessage name={`instructionalArea[${index}].labDetails`} component="div" className="text-danger" />
                                </td>
                                <td>
                                  <Field
                                    as="select"
                                    className="form-control mt-0"
                                    name={`instructionalArea[${index}].buildBlockSlno`}
                                    onChange={(e) => {
                                      handleBuildBlockChange(e, index);
                                      GetFloors(e.target.value, index);
                                    }}
                                  >
                                    <option value="">--Select--</option>
                                    {building?.length > 0 &&
                                      building?.map((buildingItem, i) => (
                                        <option value={buildingItem?.floor} key={i}>
                                          {buildingItem?.build_block_name}
                                        </option>
                                      ))}
                                  </Field>
                                  <ErrorMessage name={`instructionalArea[${index}].buildBlockSlno`} component="div" className="text-danger" />
                                </td>

                                <td>
                                  {genderSelectVisibility[index] ? (
                                    <Field as="select" className="form-control mt-0" name={`instructionalArea[${index}].floorNoBuildBlock`}>
                                      <option value="">--Select--</option>
                                      {floors[index]?.length > 0 &&
                                        floors[index].map((level, i) => (
                                          <option value={level?.floor} key={i}>
                                            {level?.show}
                                          </option>
                                        ))}
                                    </Field>
                                  ) : (
                                    <Field
                                      className="form-control mt-0"
                                      value={formik?.values?.instructionalArea[index]?.floorNoBuildBlock === 0 ? "Ground" : formik?.values?.instructionalArea[index]?.floorNoBuildBlock}
                                    />
                                  )}
                                  <ErrorMessage name={`instructionalArea[${index}].floorNoBuildBlock`} component="div" className="text-danger" />
                                </td>
                                <td>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    name={`instructionalArea[${index}].noOfRooms`}
                                    onPaste={(e) => preventZeroInputAndPaste(e)}
                                    placeholder="Room No"
                                    onKeyPress={(e) => allowNumbersOnly(e)}
                                    maxLength="4"
                                    style={{ width: "5rem" }}
                                  />
                                  <ErrorMessage name={`instructionalArea[${index}].noOfRooms`} component="div" className="text-danger" />
                                </td>
                                <td>
                                  <Field
                                    type="text"
                                    onPaste={(e) => preventZeroInputAndPaste(e)}
                                    onKeyPress={(e) => {
                                      AllowFloats(e);
                                    }}
                                    className="form-control mt-0"
                                    name={`instructionalArea[${index}].length`}
                                    style={{ width: "5rem" }}
                                    placeholder="Length"
                                    onChange={(e) => handleDimensionChange(e, "length", index)}
                                  />
                                  <ErrorMessage name={`instructionalArea[${index}].length`} component="div" className="text-danger" />
                                </td>
                                <td>
                                  <Field
                                    type="text"
                                    className="form-control mt-0"
                                    name={`instructionalArea[${index}].breadth`}
                                    style={{ width: "5rem" }}
                                    placeholder="Breadth"
                                    onPaste={(e) => preventZeroInputAndPaste(e)}
                                    onKeyPress={(e) => {
                                      AllowFloats(e);
                                    }}
                                    onChange={(e) => handleDimensionChange(e, "breadth", index)}
                                  />
                                  <ErrorMessage name={`instructionalArea[${index}].breadth`} component="div" className="text-danger" />
                                </td>
                                <td>
                                  <Field
                                    type="text"
                                    className="form-control mt-0"
                                    name={`instructionalArea[${index}].height`}
                                    style={{ width: "5rem" }}
                                    placeholder="Height"
                                    onPaste={(e) => preventZeroInputAndPaste(e)}
                                    onKeyPress={(e) => {
                                      AllowFloats(e);
                                    }}
                                  />
                                  <ErrorMessage name={`instructionalArea[${index}].height`} component="div" className="text-danger" />
                                </td>
                                <td>
                                  <Field type="text" className="form-control mt-0" name={`instructionalArea[${index}].area`} placeholder="Total Area" disabled style={{ width: "7rem" }} />
                                  <ErrorMessage name={`instructionalArea[${index}].area`} component="div" className="text-danger" />
                                </td>
                                <td>
                                  <Field component="select" className="form-control mt-0" name={`instructionalArea[${index}].utilization`} style={{ width: "8rem" }}>
                                    <option value="">--select--</option>
                                    <option value="true">Utilized</option>
                                    <option value="false">Not Utilized</option>
                                  </Field>
                                  <ErrorMessage name={`instructionalArea[${index}].utilization`} component="div" className="text-danger" />
                                </td>
                                <td width="20%">
                                  <bie.Row className="align-items-center">
                                    <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11} className="">
                                      <input
                                        type="file"
                                        className="form-control mt-0"
                                        name={`instructionalArea[${index}].buildingImg`}
                                        accept="image/*"
                                        onChange={(e) => {
                                          let filename = `buildingImg`;
                                          let path = "/Uploads/LabImage/";
                                          ImagePdfBucket(e, formik, path, `instructionalArea[${index}].buildingImg`, filename, "image");
                                        }}
                                      />
                                      <ErrorMessage name={`instructionalArea[${index}].buildingImg`} component="div" className="text-danger" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                                      {formik?.values?.instructionalArea[index]?.buildingImg && (
                                        <p
                                          role="button"
                                          tabIndex={0}
                                          className="btn btn-primary"
                                          onClick={() => {
                                            viewImage(formik?.values?.instructionalArea[index]?.buildingImg);
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                              viewImage(formik?.values?.instructionalArea[index]?.buildingImg);
                                            }
                                          }}
                                        >
                                          <BsEyeFill size={12} />  </p>
                                      )}
                                    </bie.Col>
                                  </bie.Row>
                                </td>
                                <td align="center">
                                  {index === 0 && (
                                    <button
                                      type="button"
                                      className="button-title btn btn-sm btn-success"
                                      onClick={() => {
                                        push({
                                          labType: "",
                                          labDetails: "",
                                          buildBlockSlno: "",
                                          floorNoBuildBlock: "",
                                          noOfRooms: "",
                                          length: "",
                                          breadth: "",
                                          height: "",
                                          area: "",
                                          utilization: "",
                                          buildingImg: "",
                                        });
                                      }}
                                    >
                                      <VscDiffAdded />
                                    </button>
                                  )}
                                  {index >= 1 && (
                                    <button
                                      type="button"
                                      className="button-title btn btn-sm btn-danger"
                                      onClick={() => {
                                        remove(index);
                                      }}
                                    >
                                      <BiTrash />
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </>
                        );
                      }}
                    </FieldArray>
                  </tbody>
                </table>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                {paymentDone ? (
                  <div style={{ color: "green", fontWeight: "bold" }}>✅ Already submitted</div>
                ) : (
                  <button type="submit" className="btn btn-success btn-sm mt-2 float-end">
                    Submit
                  </button>
                )}
              </div>
            </Form>
          </FormikProvider>
        </div>
      </div>
    </>
  );
}
